import { BrowserModule } from '@angular/platform-browser';
import { INAVISTA_API } from '@inavista/components/core';
import { ErrorHandler, inject, NgModule, provideAppInitializer } from '@angular/core';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AsyncPipe } from '@angular/common';
import { AuthService } from './modules/auth/services/auth.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { HttpConfigInterceptor } from './shared/interceptor/httpconfig.interceptor';
import { HomeService } from './modules/home/services/home.service';
import { SharedModule } from './shared/shared.module';
import { CommonService } from './shared/services/common.service';
import { AppParametersService } from './shared/services/app-parameters.service';
import { CycleCountService } from './modules/home/modules/cycle-counts/cycle-counts.service';
import { MessagingService } from './shared/services/messaging.service';
import { SharedLibModule } from "../../../shared/src/lib/shared.module";
import { CommentsComponent, VacationRequestsPopupService, VacationsRequestModule } from 'projects/shared/src/public-api';

import { APP_CONFIG } from 'projects/shared/src/lib/app-config.token';
import { ChunkLoadErrorHandler } from 'projects/shared/src/lib/utils/chunk-load-error-handler';
import { environment } from '../environments/environment';
import { SalesVacationRequestsPopupService } from 'projects/sales/src/app/shared/services/sales-vacation-requests-popup.service';
import { ImpersonationService } from './shared/services/impersonation.service';


export function initApp(commonservice: CommonService) {
  return () => {
    // alert("A initApp")
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('access_token');
    if (token) {
      const USER = localStorage.getItem('USER');
      localStorage.clear();
      localStorage.setItem('USER', USER);
      localStorage.setItem('access_token', token);
      commonservice.setUSERData(true);
    } else {
      if (!!localStorage.getItem('access_token')) {
        // this.router.navigate(['/home']); // Redirect to the desired route
      } else {
        // Handle error if token is not present
        console.error('Token not found in URL');
        window.location.href = environment.loginAppUrl;
      }
    }
  };
}
@NgModule({ declarations: [
        AppComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        // NgxTributeModule,
        SharedModule,
        VacationsRequestModule,
        CommentsComponent
    ],
    providers: [
        // Layout persistence for @inavista/components grids (RIMS API api/prefs).
        { provide: INAVISTA_API, useValue: { baseUrl: environment.apiUrl } },
        // Angular CDK 20+ puts dialogs in the browser's top layer (popover), above every z-index. The app shows the comments
        // panel, Syncfusion popups and SweetAlert boxes outside the dialogs, so keep overlays in the page as in Angular 17.
        { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
        // Reloads once when a tab still running an older build can't load a lazy-loaded file after a deployment
        { provide: ErrorHandler, useClass: ChunkLoadErrorHandler },
        AuthService,
        MessagingService,
        HomeService,
        AsyncPipe,
        CycleCountService,
        provideAppInitializer(() => {
            const commonService = inject(CommonService);
            const appParameters = inject(AppParametersService);
            // Impersonation (Dev / Test): the token may have changed since the last page; then load the user again.
            const tokenChanged = ImpersonationService.onStartup();
            initApp(commonService)();
            // Parameters after the user: the call needs the login token. A failure never blocks start-up.
            return (tokenChanged ? commonService.setUSERData() : commonService.loadUSER()).then(() => appParameters.load());
        }),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpConfigInterceptor,
            multi: true
        },
        {
          provide: VacationRequestsPopupService,
          useClass: SalesVacationRequestsPopupService
        },
        {
            provide: APP_CONFIG,
            useValue: {
                apiUrl: environment.apiUrl,
                saleApiUrl: environment.saleApiUrl,
                masterApiURL: environment.masterApiURL,
                encryptionSecret: environment.encryptionSecret,
                appName: 'service'
            }
        },
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class AppModule { }
